var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotFound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13,
    width: 38,
    height: 30,
    rx: 9,
    stroke: "#8F27C7",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9974 31.5698L24.0649 30.6643L26.3704 28.4254L26.7398 28.0667L26.3705 27.708L24.0648 25.468L24.9974 24.5624L27.3252 26.8228L27.6736 27.1611L28.0219 26.8228L30.3497 24.5624L31.2823 25.4679L28.9755 27.708L28.6061 28.0667L28.9755 28.4254L31.2823 30.6654L30.3508 31.5699L28.0218 29.3093L27.6735 28.9712L27.3252 29.3094L24.9974 31.5698ZM16.0026 20.7667L16.0021 20.7667C14.4675 20.7682 13.1936 21.9689 13.1711 23.4935C13.1485 25.0184 14.387 26.2546 15.9213 26.2988C17.3069 26.3387 18.5105 25.3943 18.782 24.0887H18.8368V23.6353V23.5333C18.8368 21.9916 17.5539 20.7667 16.0026 20.7667ZM10.8593 35.5H9.52023C9.78297 32.2658 12.5724 29.7 16.0026 29.7C19.4328 29.7 22.2222 32.2658 22.4849 35.5H21.1459C20.8878 32.9439 18.6714 30.9667 16.0026 30.9667C13.3338 30.9667 11.1174 32.9439 10.8593 35.5ZM16.002 27.5667C13.6862 27.5663 11.8342 25.747 11.8342 23.5333C11.8342 21.3195 13.6865 19.5 16.0026 19.5C18.3184 19.5 20.1706 21.3192 20.171 23.5327C20.1681 25.7457 18.3172 27.5639 16.002 27.5667Z",
    fill: "#D2DAE4",
    stroke: "#8F27C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12L30 11C30 5.47715 25.5228 1 20 1V1C14.4772 0.999999 10 5.47715 10 11L10 12",
    stroke: "#8F27C7",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotFound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notFound.61ec168fee993925e7d3f25e56a171c5.svg";